import { Stack, SxProps, Theme } from '@rossum/ui/material';
import { gridClasses, GridRow, GridRowProps } from '@rossum/ui/x-data-grid-pro';
import { restrictedAccessIconLabel } from './RestrictedAccessIcon';

export const disabledContainerStyles: SxProps<Theme> = {
  pointerEvents: 'none',
  [`* .${gridClasses.cellCheckbox}, .${restrictedAccessIconLabel}`]: {
    pointerEvents: 'auto',
  },
  userSelect: 'none',
  // select all except class and class' children
  [`*:not(.${restrictedAccessIconLabel}, .${restrictedAccessIconLabel} *, .${gridClasses.cellCheckbox} *)`]:
    {
      color: t => `${t.palette.action.disabled} !important`,
    },
};

type DisabledRowProps = GridRowProps;

export const DisabledRow = (props: DisabledRowProps) => {
  return (
    <Stack data-cy="annotation-row-disabled" sx={disabledContainerStyles}>
      <GridRow {...props} />
    </Stack>
  );
};
